import { useSyncExternalStore } from 'react'
import { pubSub } from '../../app-state/pubSub'
import { appState } from '../../app-state/state.app'

const subGrid = (callback) => pubSub.GRID.on('state', callback)
const getGridStateSelector = (attribute) => () => appState().GRID?.[attribute]

export const useGridLargePreviewPinnedAppState = (): number => {
    return useSyncExternalStore(
        subGrid,
        getGridStateSelector('largePreviewPinnedID'),
        getGridStateSelector('largePreviewPinnedID'),
    )
}
